import { render } from "./empty.vue?vue&type=template&id=643658b7&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"

import "./empty.vue?vue&type=style&index=0&id=643658b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643658b7"]])

export default __exports__